import { Badge, Button, FormField, Link, SegmentedControl, SelectProps, Table } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import Pagination from '@cloudscape-design/components/pagination';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useRef, useState } from 'react';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import { mdiFileExcel, mdiGasStationOffOutline, mdiRefresh } from '@mdi/js';
import Icon from '@mdi/react';
import * as XLSX from "xlsx";
import Favorites from '../../../../../components/extras/Favorites';
import SidePanelMovement from '../../../../../components/extras/SidePanelMovement';
import MPModal from '../../../../../components/MPModal';
import SelectPaging from '../../../../../components/selects/selectPaging';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemsMovement } from '../../../../../resources/types';
const _preserve = React.version;

const pageSize = 20;
type OptionDefinition = SelectProps.Option;

export const ReportsOpsFuelMovementsPage = () => {
    const { menu, parameters, data } = useGlobalState();


    const [type, setType] = useState("");
    const [movements, setMovements] = useState<ItemsMovement[]>([]);
    const [movement, setMovement] = useState<ItemsMovement>();
    const [movementsAll, setMovementsAll] = useState<ItemsMovement[]>([]);

    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filterValue, setFilterValue] = useState("");

    useEffect(() => {
        setMovements(movementsAll)
    }, [parameters.startDate, parameters.endDate, type]);


    useEffect(() => {
        if (window.location.hash.split("?")[1] === undefined)
            handleCheckFuel();
        else
            window.location.hash = "#reports/ops/fuelmovements"
    }, [parameters, type]);


    const mountedRef = useRef(false);
    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");
            if (id) {
                if (!mountedRef.current) {
                    mountedRef.current = true;
                    handleCheckFuel()
                }
                setMovement(undefined)
                handleGetMovement(parseInt(id))
            } else {
                setMovement(undefined)
                handleCheckFuel();
            }
        };
        window.addEventListener("hashchange", handleHashChange);
        handleHashChange();
        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);

    const handleGetMovement = async (id: number) => {

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/movement',
                    'JWT': getCookie("JWT"),
                },
                body: JSON.stringify({
                    idMovement: id,
                    columns: "idMovement,idUser,RUT,accountPlan,ammount,balance,data,obs,dateTransaction,displayName,idAccountPlan,idCharge,receipt,jsonBank,jsonDocuments,jsonMovement,jsonTBK, idFlight, tbkCodAuto"
                }),
                //mode: 'no-cors'  // Bypasses CORS but limits the response
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                console.log(data.movement)
                setMovement(data.movement);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }
    const handleCheckFuel = async () => {
        if (parameters && parameters.startDate && parameters.endDate && type !== "") {
            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/movements/list',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        limit: 1000,
                        isFuel: true,
                        fuelType: type,
                        month: parameters.month,
                        year: parameters.year,
                        orderBy: "receipt",
                        order: "desc",
                        columns: "idMovement,idUser,RUT,accountPlan,ammount,balance,data,dateTransaction,displayName, idAccountPlan,idCharge,receipt,jsonBank,jsonDocuments,jsonMovement,jsonTBK"
                    }),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    setMovementsAll(data.movements);
                    setMovements(data.movements);
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }
        }
    }

    const filtered: ItemsMovement[] = movements.filter((item) => {
        const searchWords = filterValue.toLowerCase().split(/\s+/).filter(Boolean);
        const text = [item.data, item.RUT, item.ammount.toString(), item.displayName, item.idMovement.toString()].join(" ").toLowerCase().replace(/[^a-z0-9]/g, "");
        return searchWords.every((word) => text.includes(word.replace(/[^a-z0-9]/g, "")));
    });
    const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);
    const tableRef = useRef(null);

    const excel = filtered.map((m: ItemsMovement) => (
        {
            idMovement: m.idMovement,
            fecha: m.dateTransaction,
            folio: m.receipt,
            glosa: m.data,
            observaciones: m.obs,
            matricula: m.jsonMovement.registration,
            total: m.jsonMovement.liters * m.jsonMovement.price,
            facturado: m.ammount,
            litros: m.jsonMovement.liters,
            precio: m.jsonMovement.price,
            numInicial: m.jsonMovement.counterStart,
            numFinal: m.jsonMovement.counterEnd,
            factura: m.jsonDocuments.number

        }
    )) || []

    const exportToExcel = () => {
        // Convert JSON to worksheet
        const ws = XLSX.utils.json_to_sheet(excel);

        // Create a workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Consumos");

        // Generate XLSX file and download
        XLSX.writeFile(wb, `report.fuel.${parameters.year}-${parameters.month}.${type}.xlsx`);
    };
    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={!!movement}
            onSplitPanelToggle={({ detail }) => !detail.open ? window.location.hash = "#reports/ops/fuelmovements" : null}
            splitPanel={movement && (
                <SidePanelMovement movement={movement ?? {}} />
            )}
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header actions={<Favorites />} //info={<Link onClick={() => setHelpOpen(!helpOpen)}><Icon path={mdiHelpCircleOutline} size={1}></Icon></Link>}
                        >
                            Movimientos de combustibles {movements.length > 0 ?
                                filtered.length !== movements.length ? `(${filtered.length} de ${movements.length})` : `(${movements.length})` : ""}
                        </Header>

                        <SpaceBetween direction='vertical' size='xs'>

                            <Table ref={tableRef}
                                variant="embedded"
                                //onRowClick={({ detail }) => { setMovement(detail.item); setDetailPanel(true); //console.log(detail.item.jsonDocuments) }}
                                stickyHeader
                                filter={

                                    <SpaceBetween direction="horizontal" size="xs">
                                        <FormField label="Tipo de combustible">
                                            <SegmentedControl
                                                selectedId={type}
                                                onChange={({ detail }) => {
                                                    setType(detail.selectedId)
                                                }}
                                                label="Tipo combustible"
                                                options={[
                                                    { text: "AVGAS", id: "AVGAS" },
                                                    { text: "JP1", id: "JP1" },
                                                ]}
                                            />
                                        </FormField>
                                        <FormField label="Periodo">
                                            <div style={{ width: 130 }}>

                                                <MPModal
                                                    width={120}
                                                    today prevMonth nextMonth end={new Date()}
                                                    date={`${parameters.year}-${parameters.month}`}
                                                    onConfirm={(date) => {
                                                        setParameters({ ...parameters, month: date.month, year: date.year });
                                                    }}
                                                />
                                            </div>
                                        </FormField>

                                        <FormField label="&nbsp;">
                                            {parameters.month && parameters.year && (<Button style={{ root: btnIconForm }} onClick={handleCheckFuel}><Icon path={mdiRefresh} size={1} /></Button>)}
                                        </FormField>

                                        <FormField label="&nbsp;">
                                            <Button style={{ root: btnIconForm }} disabled={excel.length === 0} onClick={exportToExcel}><Icon path={mdiFileExcel} size={1} /></Button>
                                        </FormField>
                                    </SpaceBetween>
                                }


                                pagination={

                                    <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                                        {filtered.length > parameters.pageSize && (
                                            <Pagination
                                                currentPageIndex={currentPageIndex}
                                                pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                                                onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                            />
                                        )}

                                        {movements.length > 0 && (
                                            <SelectPaging onSelect={(pageSize) => {
                                                setCurrentPageIndex(1);
                                                setParameters({ ...parameters, pageSize: pageSize });
                                            }} />
                                        )}
                                    </SpaceBetween>
                                }

                                columnDefinitions={[
                                    {
                                        id: "dateTransaction",
                                        header: "ID/Fecha",
                                        cell: item => (

                                            <FormField
                                                label={<Link
                                                    onClick={() => {
                                                        window.location.hash = `#reports/ops/fuelmovements?id=${item.idMovement}`;
                                                    }}
                                                >{item.idMovement}</Link>}
                                                description={item.dateTransaction}
                                            />
                                        ),
                                        width: 120
                                    },
                                    {
                                        id: "number",
                                        header: "Folio",
                                        cell: item => item.receipt,
                                        width: 120
                                    },
                                    {
                                        id: "idUser",
                                        header: "Usuario",
                                        cell: item => (

                                            <FormField
                                                description={item.jsonMovement.registration ?
                                                    item.jsonMovement.registration :
                                                    <Badge color='red'>Anulado</Badge>
                                                }
                                                label={item.displayName}
                                            />
                                        )
                                    },
                                    {
                                        id: "data",
                                        header: "Glosa",
                                        cell: item => (

                                            <FormField
                                                description={item.jsonMovement.registration ?
                                                    `${item.jsonMovement.counterEnd} - ${item.jsonMovement.counterStart} = ${item.jsonMovement.liters} LTS x ${item.jsonMovement.price} = ${item.ammount}`
                                                    : "·"}
                                                label={item.data}
                                            />
                                        )
                                    },
                                    {
                                        id: "charge",
                                        header: "Cargo",
                                        cell: item => (
                                            <FormField

                                                label={
                                                    (item.ammount < 0 ?
                                                        item.ammount.toLocaleString('es-CL', {
                                                            style: 'currency',
                                                            currency: 'CLP',
                                                            maximumFractionDigits: 2
                                                        }) : <><Icon path={mdiGasStationOffOutline} size={1} /></>)
                                                }
                                            />
                                        )


                                    },
                                ]}
                                trackBy="idMovement"
                                items={paginated ?? []}
                                empty={
                                    <Box
                                        margin={{ vertical: "xs" }}
                                        textAlign="center"
                                        color="inherit"
                                    >
                                        <SpaceBetween size="m">
                                            <b>Sin movimientos asociados</b>
                                        </SpaceBetween>
                                    </Box>
                                }
                            />
                        </SpaceBetween>
                    </SpaceBetween>


                </>
            }
        />
    );
};
